import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "../layout/AppLayout";
import { useCheckAuth } from "./useCheckAuth";
import Loading from "../../extras/loading/Loading";

export default function PrivateRoute() {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useCheckAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return <Loading />;
  }

  return isAuthenticated ? <AppLayout /> : null;
}
